import React from "react";

const TERMS_DOCUMENT_URL = "/legal/terms.html";

export default function Terms() {
  return <main className="min-h-screen bg-bone pt-16" data-testid="terms-page"><iframe title="FYLLR Terms & Conditions" src={TERMS_DOCUMENT_URL} className="min-h-[calc(100vh-4rem)] w-full border-0 bg-bone" data-testid="terms-document-frame" /></main>;
}